/* eslint-disable import/prefer-default-export */
import * as Yup from 'yup'

export const SUPPORTED_FORMATS_IMG = [
  'image/jpg',
  'image/jpeg',
  'image/gif',
  'image/png',
  'image/svg+xml',
]

export const SUPPORTED_FORMATS_DOC = [
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/pdf',
]

export const regExPincode = /^[1-9][0-9]{5}$/

// eslint-disable-next-line func-names
Yup.addMethod(Yup.string, 'pincode', function() {
  return this.test('pincode', 'Enter valid Pincode', value => regExPincode.test(value))
})

export const checkFileType = files => {
  let valid = true
  
  if (files && files.length > 0) {
    files.map(file => {
      
      if (file.type && !SUPPORTED_FORMATS_IMG.includes(file.type)) {
        valid = false
      } else if (!file.type && !file.url) valid = false
      return ''
    })
  }
  return valid
}

const checkResumeFileType = files => {
  let valid = true
  
  if (files && files.length > 0) {
    files.map(file => {
      
      if (file.type && !SUPPORTED_FORMATS_DOC.includes(file.type)) {
        valid = false
      } else if (!file.type && !file.url) valid = false
      return ''
    })
  }
  return valid
}

export const careerSchema = Yup.object().shape({
  name: Yup.string().required('Required'),
  email: Yup.string().required('Required'),
  experience: Yup.string().required('Required'),
  employed: Yup.string().required('Required'),
  mobile: Yup.string().required('Required'),
  qualification: Yup.string().required('Required'),
  designation: Yup.string().required('Required'),
  resume: Yup.array()
  .nullable()
  .test('emptyArray', 'A file is required', a => a && a.length !== 0)
  .required('A file is required')
  .test('fileFormat', 'Unsupported Format. Required: doc/ docx/ pdf', checkResumeFileType),
  // designation: Yup.string().required('Required'),
  // resume: Yup.array()
  //   .nullable()
  //   .required('A file is required')
  //   .test('fileFormat', 'File must be pdf/doc/docx', checkResumeFileType),
})

export const contactSchema = Yup.object().shape({
  firstName: Yup.string().required('Required'),
  lastName: Yup.string(),
  phoneNo: Yup.string().required('Required'),
  message: Yup.string().required('Required'),
  email: Yup.string()
    .email('Invalid email')
    .required('Required'),
})

export const slotSchema = Yup.object().shape({
  slots: Yup.string().required('Required'),
  
})

export const consultationSchema = Yup.object().shape({
  name: Yup.string().required('Required'),
  mobile: Yup.string().required('Required'),
  email: Yup.string()
    .email('Invalid email')
    .required('Required'),
  speciality: Yup.string().required('Required'),
  doctor: Yup.string().required('Required'),
  dateAppointment: Yup.string()
    .required('Required')
    .test('date', 'Please choose valid date!', a => {
      const booked = new Date(a)
      const now = new Date()
      const bookedMonth = booked.getMonth()
      const nowMonth = now.getMonth()
      if (bookedMonth === nowMonth) return booked.getDate() >= now.getDate()
      return booked >= now
    }),
  gender: Yup.string().required('Required'),
  age: Yup.string().required('Required'),
  address: Yup.string().required('Required'),
  hospitalNo: Yup.string(),
  country: Yup.string(),
  state: Yup.string(),
  city: Yup.string(),
  // pincode: Yup.string().pincode(),
  pincode: Yup.string(),
  referringPhysician: Yup.string(),
  medicalHistory: Yup.string(),
  reports: Yup.array()
    .nullable()
    // .test('emptyArray', 'A file is required', a => a && a.length !== 0)
    // .required('A file is required')
    .test('fileFormat', 'Unsupported Format', checkResumeFileType),
})

export const bookingSchema = Yup.object().shape({
  patient_name: Yup.string().required('Required'),
  mobile_number: Yup.string().required('Required'),
  // email: Yup.string()
  //   .email('Invalid email')
  //   .required('Required'),
  // op_number: Yup.string().required('Required'),
  gender: Yup.string().required('Required'),
  age: Yup.string().required('Required'),
  address: Yup.string().required('Required'),
  // checking: Yup.boolean(),
  // dateAppointment: Yup.string()
  //   .required('Required')
  //   .test('date', 'Please choose valid date!', a => {
  //     const booked = new Date(a)
  //     const now = new Date()
  //     const bookedMonth = booked.getMonth()
  //     const nowMonth = now.getMonth()
  //     if (bookedMonth === nowMonth) return booked.getDate() >= now.getDate()
  //     return booked >= now
  //   }),

})
